import React from "react";
import HeadManager from "./HeadManager";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LogoLoader from "./LogoLoader";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { protectedPages, isPathMatched } from "@/lib/protected";
import baseUrl from "@/utils/baseUrl";
import axios from "axios";
import useSWR from "swr";
import { Flex } from "@mantine/core";
const fetcher = (args) => axios.get(...args).then((res) => res.data);

const Layout = ({ children }) => {
  const [pageLoading, setPageLoading] = React.useState(true);
  const router = useRouter();
  const { data: session, status } = useSession();
  const {
    data: user,
    error,
    isLoading,
  } = useSWR(session ? [`${baseUrl}/api/v1/auth/account`] : null, fetcher, { shouldRetryOnError: false });

  React.useEffect(() => {
    if (status !== "loading" && (status === "unauthenticated" || !isLoading)) {
      setPageLoading(false);
    }
    if (session && router.pathname === "/authentication") {
      router.push("/");
    } else if (router.pathname !== "/logout" && (error?.response?.status === 401 || error?.response?.status === 403)) {
      router.push("/logout");
    } else if (status !== "loading" && !session && isPathMatched(router.pathname, protectedPages)) {
      router.push("/authentication");
    }
  }, [router.pathname, router.events, session, error, status, isLoading, router.query]);

  return (
    <>
      <HeadManager pathname={router.pathname} />
      <Navbar user={user} />
      {pageLoading ? (
        <LogoLoader />
      ) : (
        <>
          <MainContainer user={user}>{children}</MainContainer>
          <Footer user={user} />
        </>
      )}
    </>
  );
};

const MainContainer = ({ children, user }) => (
  <Flex id="main-container" direction="column" flex={1}>
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { user });
      }
      return child;
    })}
  </Flex>
);

export default Layout;
